"use client"

const UPSELL_CHANNEL_KEY_PREFIX = "up_channel_"

const upsellIdFromPath = (path: string): string | null => {
  const match = path.match(/\/up\/([^/?#]+)/)
  if (!match) {
    return null
  }
  try {
    return decodeURIComponent(match[1])
  } catch {
    return null
  }
}

const resolveUpsellId = (upsellIdOrUrl: string): string | null => {
  if (upsellIdOrUrl.includes("/up/")) {
    return upsellIdFromPath(upsellIdOrUrl)
  }
  // Looks like a path but lacks /up/<id> — refuse so non-upsell
  // redirects (e.g. /order/confirm) don't pollute localStorage.
  if (upsellIdOrUrl.startsWith("/") || upsellIdOrUrl.startsWith("http")) {
    return null
  }
  return upsellIdOrUrl
}

export const persistUpsellChannel = (
  upsellIdOrUrl: string,
  channel: string
) => {
  if (typeof window === "undefined") {
    return
  }
  const upsellId = resolveUpsellId(upsellIdOrUrl)
  if (!upsellId || !channel) {
    return
  }
  try {
    window.localStorage.setItem(
      `${UPSELL_CHANNEL_KEY_PREFIX}${upsellId}`,
      channel
    )
  } catch {
    // localStorage may be unavailable, full, or blocked — fail silently
  }
}

export const readUpsellChannel = (upsellId: string): string | null => {
  if (typeof window === "undefined") {
    return null
  }
  try {
    return window.localStorage.getItem(
      `${UPSELL_CHANNEL_KEY_PREFIX}${upsellId}`
    )
  } catch {
    return null
  }
}
